import { render, staticRenderFns } from "./TabAvailability.vue?vue&type=template&id=3aed6d6a"
import script from "./TabAvailability.vue?vue&type=script&lang=js"
export * from "./TabAvailability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports